import { AutoCompleteMulti, ISelectType, useFetch } from "@4uhub/lib4uhub";
import { Grid } from "@mui/material";
import { memo, useCallback, useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { calendarRegisterList } from "../../../../../../../services/ticketAutomationReceivedSlotCalendar.service";

const translationPath =
  "chatBot.page.automations.automationReceivedRules.automationReceivedMessages.";

export const ReceivedMessageCalendars = memo(() => {
  const { t } = useTranslation();

  const { sendRequest: calendarsRequest } = useFetch(calendarRegisterList);

  const [optionsCalendars, setOptionsCalendars] = useState<ISelectType[]>([]);

  const params = useMemo(() => {
    return { EnableCode: true, TasyScheduleTypeCode: "3" };
  }, []);

  const fetchCalendars = useCallback(async () => {
    const { data, success } = await calendarsRequest(params);

    if (data && success) {
      const formattedOptions = data.map((d) => {
        const descriptionSite = d.descriptionSite?.trim();
        const calendarShortName = d.calendarShortName?.trim();
        const calendarName = d.calendarName?.trim();
        const inicialName =
          [descriptionSite, calendarShortName, calendarName].find(Boolean) ||
          d.identifier.toString();

        return {
          id: d.identifier.toString(),
          name: inicialName + " - " + d.identifier,
        };
      });
      setOptionsCalendars(formattedOptions);
    }
  }, [calendarsRequest]);

  useEffect(() => {
    fetchCalendars();
  }, [fetchCalendars]);

  return (
    <Grid item xs={12} sm={12}>
      <AutoCompleteMulti
        name="calendars"
        size="small"
        fullWidth
        options={optionsCalendars}
        label={t(translationPath + "agendas")}
        getOptionLabel={(option) => option.name}
        keepOpenOnSelect
      />
    </Grid>
  );
});
